import { render, staticRenderFns } from "./fulfillment-detail-ja-campaigns.vue?vue&type=template&id=2e00ae24"
import script from "./fulfillment-detail-ja-campaigns.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail-ja-campaigns.vue?vue&type=script&lang=js"
import style0 from "./fulfillment-detail-ja-campaigns.vue?vue&type=style&index=0&id=2e00ae24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports